import React, { useState } from 'react';
import { AGENDADA } from '../../../../data/audienceStates';
import { Button } from 'react-bootstrap';
import { ICON_EDIT } from '../../../extras/icons';
import SessionEditForm from './forms/SessionEditForm';
import { useSelector } from 'react-redux';
import AuthoritiesService from '../../../../services/AuthoritiesService';
import { SOLICITUDES_MODIFICAR } from '../../../../data/objects';
//Función principal
const AudienceSession = props => {
    //Tomo los props
    const { audience } = props;
    //Traigo el store
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [showEdit, setShowEdit] = useState(false);
    //Manejo la apertura
    const handleOpen = () => {
        setShowEdit(true);
    }
    //Manejo el cierre
    const handleClose = () => {
        setShowEdit(false);
    }
    //Analizo si puede editar
    let canEdit = false;
    if(audience){
        if(audience.estado && audience.estado.id == AGENDADA){
            //Verifico permisos
            if(authorities && AuthoritiesService.hasPermission(authorities, SOLICITUDES_MODIFICAR)){
                //Puede editar
                canEdit = true;
            }
        }
    }
    //Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">ENLACE DE AUDIENCIA REMOTA</h6>
                    <div className="dropdown no-arrow">
                        {
                            canEdit ? (
                                <Button variant="light" size="sm" className="float-right text-gray-400" onClick={handleOpen}>
                                    <ICON_EDIT />
                                </Button>
                            ) : null
                        }

                        <SessionEditForm
                            show={showEdit}
                            handleClose={handleClose}
                            audience={audience}
                        />
                    </div>
                </div>
                <table className="table table-hover table-sm">
                    <thead className="thead-light">
                        <tr>
                            <th className="text-center">Dirección de enlace</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            audience.sessionUrl ? (
                                <tr>
                                    <td className="align-middle text-center">
                                        <a href={audience.sessionUrl} target="_blank">{ audience.sessionUrl }</a>
                                    </td>
                                </tr>
                            ) : null
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AudienceSession;